import { RetryError, toError } from '../errors';

type AsyncFunc = (...args: any) => Promise<any>;

type RetryGenerator = <T extends AsyncFunc>(asyncFn: T, numberOfRetries: number) => T;

const retry: RetryGenerator = (asyncFn, numberOfRetries) => {
    // have to do this because typescript is too smart here with generics type constrains
    // clients of this function will get the proper types though
    const wrapper: any = async (...args: Parameters<typeof asyncFn>) => {
        const errors: Array<Error> = [];

        for (let i = 0; i < numberOfRetries + 1; i++) {
            try {
                /* eslint-disable-next-line no-await-in-loop */
                const res = await asyncFn(...args);
                return res;
            } catch (err) {
                // rethrow the special redirect CustomFetchApiError that is logged as info
                if (err.isRedirect) {
                    throw err;
                }
                errors.push(toError(err));
            }
        }

        throw new RetryError(errors);
    };

    return wrapper;
};

export default retry;
